import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Hero from '@/components/sections/Hero';
import BreakfastProgram from '@/components/sections/BreakfastProgram';
import Values from '@/components/sections/Values';
import ProductGrid from '@/components/sections/ProductGrid';
import CampusFormats from '@/components/sections/CampusFormats';
import WhoWeServe from '@/components/sections/WhoWeServe';
import CtaBand from '@/components/sections/CtaBand';
import EventBanner from '@/components/sections/EventBanner';
import Partners from '@/components/sections/Partners';
import FAQ from '@/components/sections/FAQ';

export default function Landing() {
  return (
    <main className="min-h-screen bg-background">
      <Header />
      <Hero />
      <BreakfastProgram />
      <Values />
      <ProductGrid />
      <CampusFormats />
      <WhoWeServe />
      <CtaBand />
      <EventBanner />
      <Partners />
      <FAQ />
      <Footer />
    </main>
  );
}
